import { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getRockerboxEmployersRoute } from '../api/constant';
import { rockerEmployerList } from '../constants';

type useGetrockerboxEmployersProps = {
    searchValue: string;
    sortedDirection: string;
    enabled: string | boolean;
    page: number;
    columnNo: number;
    page_length: number;
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useGetrockerboxEmployers = ({
    page,
    page_length,
    enabled,
    columnNo,
    sortedDirection,
    searchValue,
    setAlertText = () => { },
}: useGetrockerboxEmployersProps) => {
    const client = useQueryClient();

    const queryString = `?page=${page}&page_length=${page_length}&query=${searchValue}&sort_columns=${columnNo}&sort_direction=${sortedDirection}&wotc_enabled=${enabled}`;
    const { data: rockerboxList, isFetching: isLoadingrockerboxList } =

        useQuery({
            queryKey: [columnNo, sortedDirection, rockerEmployerList, page, searchValue, page_length, enabled],
            queryFn: () =>

                axiosInstance
                    .get(getRockerboxEmployersRoute + queryString)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setAlertText(data.message);
                } else {
                    setAlertText('');
                }
            },
            onError: () => {
                setAlertText(errorMessage);
                client.invalidateQueries([rockerEmployerList]);
            },
            refetchOnWindowFocus: false,
        });

    return {
        rockerboxList,
        isLoadingrockerboxList,
    };
};
